<template>
    <div class="loading_wrapper">
        <LoadingIndicator class="primary big"></LoadingIndicator>
    </div>
</template>
<style lang="scss">
    .loading_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width: 100%;
    }
</style>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    import lStorage from '@/store/localStorage';
    import Cookie from '@/store/cookie';
    import env from '@/enviroment';
    import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';
    
    export default {
        name:'ReferralInvite',
        components:{
            LoadingIndicator
        },
        data:function(){
            return{}
        },
        methods:{},
        mounted(){
            //Проверяем наличие идентификатора
            if(this.$route.params.id && this.$route.params.id.toString().trim().length==36){
                Cookie.set("referral",this.$route.params.id,{
                    "domain":"."+env.domain
                });
                //Отправляем на регистрацию
                lStorage.remove('auth-token');
                window.location.replace(env.homepage+"?referral="+this.$route.params.id);
                return;
            }
            lStorage.remove('auth-token');
            this.$router.push({
                name:"LoginPage",
                params:{
                    locale:this.$route.params.locale,
                },
            });
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            },
        },
    }
</script>